import React from 'react';
import styles from './index.module.scss';

export type TextPropsType = {
	text: string;
	style?: React.CSSProperties;
};

type AllTextPropsType = TextPropsType & { className?: string };

export function Text({ text, style = {}, className }: AllTextPropsType) {
	return (
		<span
			role="row"
			className={`${styles.text} ${className}`}
			tabIndex={0}
			style={style}
		>
			{text}
		</span>
	);
}
